import React from 'react';
/*
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from "reactstrap";
*/
import styles from './index.module.css';

class AppFooter extends React.Component {
  render() {
    return (
      <div className="fixed-bottom">
        <footer className={styles['footer']}>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              &copy;{new Date().getFullYear()} Cause Inspired Media. All Rights
              Reserved.
            </div>
            <div>
              <a
                href="https://philanthropic.ly/terms-of-use/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms Of Use
              </a>
              {' • '}
              <a
                href="https://philanthropic.ly/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/app/shared/AppFooter/index.js